import { render, staticRenderFns } from "./DocPreviewCallback.vue?vue&type=template&id=af82861c&"
import script from "./DocPreviewCallback.vue?vue&type=script&lang=ts&"
export * from "./DocPreviewCallback.vue?vue&type=script&lang=ts&"
import style0 from "./DocPreviewCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports